define('w3c/linter-rules/privsec-section',["exports", "core/LinterRule", "../l10n"], function (exports, _LinterRule, _l10n) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.rule = undefined;

  var _LinterRule2 = _interopRequireDefault(_LinterRule);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  const name = "privsec-section";
  const meta = {
    en: {
      description: "Document must a 'Privacy and/or Security' Considerations section.",
      howToFix: "Add a privacy and/or security considerations section.",
      help: "See the [Self-Review Questionnaire](https://w3ctag.github.io/security-questionnaire/)."
    }
  };

  // Fall back to english, if language is missing
  const lang = _l10n.lang in meta ? _l10n.lang : "en";

  function hasPriSecConsiderations(doc) {
    return Array.from(doc.querySelectorAll("h2, h3, h4, h5, h6")).some(({ textContent: text }) => {
      const saysPrivOrSec = /(privacy|security)/im.test(text);
      const saysConsiderations = /(considerations)/im.test(text);
      return saysPrivOrSec && saysConsiderations || saysPrivOrSec;
    });
  }

  function lintingFunction(conf, doc) {
    const results = [];
    if (conf.isRecTrack && !hasPriSecConsiderations(doc)) {
      results.push(_extends({ name, occurrences: 1 }, meta[lang]));
    }
    return results;
  }

  const rule = exports.rule = new _LinterRule2.default(name, lintingFunction);
});
//# sourceMappingURL=privsec-section.js.map;
